export default {
  apiKey: 'AIzaSyBEYQnoRmgmb9SHW4OyjXSpsIAldFSxYHk',
  authDomain: 'engage4.firebaseapp.com',
  databaseURL: 'https://engage4.firebaseio.com',
  projectId: 'engage4',
  storageBucket: 'engage4.appspot.com',
  messagingSenderId: '259587820456',
  appId: '1:259587820456:web:5b71772ab2a33b23a46b9d',
  measurementId: 'G-BWN22QSWT4',
};
